import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertPassouFalhouEnumToBoolean, convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta10Model } from './model-consultaSeguimentoPergunta10'

export const convertConsultaSeguimentoPergunta10ToInput = (
  value: ConsultaSeguimentoPergunta10Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_EXEMPLOS?.PASSOU?.PROCURA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_EXEMPLOS?.PASSOU?.FALA_OU_EMITE_SOM),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_EXEMPLOS?.PASSOU?.PARA_O_QUE_ESTA_FAZENDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_EXEMPLOS?.FALHOU?.NAO_DA_RESPOSTA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_EXEMPLOS?.FALHOU?.PARECE_OUVIR_IGNORA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_EXEMPLOS?.FALHOU?.SO_RESPONDE_NA_FRENTE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_08,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_10_EXEMPLOS?.FALHOU?.SO_RESPONDE_SE_TOCADO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_10_09,
      stResposta: convertPassouFalhouEnumToBoolean(value.PERGUNTA_10_FREQUENCIA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
